import React from "react";
import { Button } from "../ui/button";

interface BatchControlsProps {
  status: "DRAFT" | "FINALIZED";
  onGenerateChecks?: () => void;
  onFinalize?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
}

const BatchControls: React.FC<BatchControlsProps> = ({
  status,
  onFinalize,
  onDelete,
  disabled,
}) => {
  return (
    <div className="flex gap-2 mb-4">
      {status === "DRAFT" && (
        <>
          <Button
            className="btn btn-success"
            onClick={onFinalize}
            disabled={disabled}
          >
            Finalize Batch
          </Button>
          <Button
            className="btn btn-danger"
            variant="destructive"
            onClick={onDelete}
            disabled={disabled}
          >
            Delete Batch
          </Button>
        </>
      )}
      {status === "FINALIZED" && (
        <span className="text-success font-semibold">
          Batch is finalized. No further changes allowed.
        </span>
      )}
    </div>
  );
};

export default BatchControls;
